import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const PermContext = createContext(null);

export function PermissionsProvider({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState({ modules: [], permissions: null });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/permissions");
      setState({ modules: data.modules, permissions: data.permissions });
    } catch { /* not authenticated */ }
  }, []);

  useEffect(() => {
    if (user && user.role) load();
  }, [user, load]);

  const can = useCallback((moduleKey) => {
    if (!user) return false;
    if (!state.permissions) return true; // fallback until loaded
    const rolePerms = state.permissions[user.role];
    if (!rolePerms) return false;
    return !!rolePerms[moduleKey];
  }, [user, state.permissions]);

  return (
    <PermContext.Provider value={{ ...state, can, refresh: load }}>
      {children}
    </PermContext.Provider>
  );
}

export const usePermissions = () => useContext(PermContext) || { can: () => true, modules: [], permissions: null };
